import React, { useEffect, useState } from "react";
import clsx from "clsx";
import styles from "./LoginForm.module.scss";
import { useLoginFormValidator } from "./hooks/useLoginFormValidator";
import axioPath from "../../../../../api/axioPath";
import AlertModal from "web/components/AlertModal";
import Spinner from "web/components/Spinner";
import { Field } from "formik";
import { Col, Row } from "reactstrap";
import RadioButton from "web/components/RadioButton";
import { checkIsZipCode } from "redux/actions/adminPtPlus/index";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NumberFormat from "react-number-format";
import ReCAPTCHA from "react-google-recaptcha";
import styled from "styled-components";
import { useRef } from "react";

const LoginForm = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [captchaStatus, setCaptchaStatus] = useState(false);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  let buySellOptions = [
    {
      name: "Buy",
      value: "BUY",
      label: "Buy",
    },
    {
      name: "Sell",
      value: "SELL",
      label: "Sell",
    },
  ];
  let locationsOptions = [
    {
      name: "One",
      value: "ONE",
      label: "One",
    },
    {
      name: "Many",
      value: "MANY",
      label: "Many",
    },
  ];

  let annualOptions = [
    {
      name: "Less than 50,000 pallets",
      value: "LESS_THAN_50000",
      label: "Less than 50,000 pallets",
    },
    {
      name: "50,001-250,000 pallets",
      value: "BETWEEN_50001_AND_250000",
      label: "50,001-250,000 pallets",
    },
    {
      name: "More than 250,000 pallets",
      value: "MORE_THAN_250000",
      label: "More than 250,000 pallets",
    },
  ];

  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    company: "",
    email: "",
    confirmemail: "",
    phone: "",
    locationCity: "",
    locationST: "",
    locationZip: "",
    // buySellOptions: "",
    // locationsOptions: "",
    // annualOptions: "",
    comment: "",
  });

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const toggleModal = () => setModal(!modal);

  const { errors, validateForm, onBlurField } = useLoginFormValidator(form);

  useEffect(() => {
    validateFormData();
  }, [form]);

  const onUpdateField = (e) => {
    const field = e.target.name;
    let value = e.target.value;
    const nextFormState = {
      ...form,
      [field]: value,
    };
    setForm(nextFormState);
    if (errors[field].dirty)
      validateForm({
        form: nextFormState,
        errors,
        field,
      });

    if (field === "locationZip") {
      if (value.length === 5) {
        callFunction(value);
      } else {
        setForm({
          ...form,
          locationCity: "",
          locationST: "",
          locationZip: value,
        });
      }
    }

    validateFormData();
  };

  const validateFormData = () => {
    let isValid = true;
    for (const [_key, value] of Object.entries(errors)) {
      if (value.error === true) {
        isValid = false;
        break;
      }
    }

    let isFilled = true;
    for (const [key, value] of Object.entries(form)) {
      if (["comment"].indexOf(key) < 0 && value === "") {
        isFilled = false;
      }
    }
    setIsFormValid(isValid && isFilled ? true : false);
  };

  const recaptchaRef = useRef();
  const onRecaptchaChange = () => {
    const recaptchaValue = recaptchaRef.current.getValue();

    if (!recaptchaValue || recaptchaValue === "") {
      setCaptchaStatus(false); // Set captchaStatus to false when expired
    } else {
      setCaptchaStatus(true); // Set captchaStatus to true when reCAPTCHA is valid
    }
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    //   if(form.buySellOptions === "BUY" && (!form.locationsOptions || !form.annualOptions)){
    //     if(!form.locationsOptions && form.annualOptions){
    //       setModalContent("Location is a required field.")
    //       setModal(true)
    //     }
    //     if(form.locationsOptions && !form.annualOptions){
    //       setModalContent("Annual basis is a required field.")
    //       setModal(true)
    //     }
    //     if(!form.locationsOptions && !form.annualOptions){
    //       setModalContent("Please select required field.")
    //       setModal(true)
    //     }
    //     return
    // }

    let securityKey = process.env.REACT_APP_SECRET_KEY;
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) return;
    else {
      let data = {
        firstname: form.firstname,
        lastname: form.lastname,
        company: form.company,
        email: form.email,
        phone: form.phone !== "" ? form.phone : "",
        city: form.locationCity,
        state: form.locationST,
        zip: form.locationZip,
        palletAction: form.buySellOptions || null,
        numberOfLocations: form.locationsOptions || null,
        annualPalletVolume: form.annualOptions || null,
        comment: form.comment !== "" ? form.comment : "",
        secretKey: securityKey,
        captcha: recaptchaRef.current.getValue(),
      };
      axioPath
        .post("welcome/create", data, {
          headers: {},
        })
        .then((response) => {
          if (response && response.data.status) {
            if (response?.data?.status === "FAILURE") {
              setModalContent(response?.data?.message);
            } else {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: "signup_form_submission" });
              setModalContent(
                "Thank you for contacting us! Someone from our team will be in touch with you soon."
              );
            }
            setModal(true);
            setForm({
              firstname: "",
              lastname: "",
              company: "",
              email: "",
              confirmemail: "",
              phone: "",
              locationCity: "",
              locationST: "",
              locationZip: "",
              // buySellOptions: "",
              // locationsOptions: "",
              // annualOptions: "",
              comment: "",
            });
            setCaptchaStatus(false);
            if (recaptchaRef.current) {
              recaptchaRef.current.reset();
            }
          } else {
            setModalContent(
              "Error occurred while registering, Please try again"
            );
            setModal(true);
          }
        })
        .catch((ex) => {
          setModalContent(ex.message);
          setModal(true);
        });
    }
  };

  const callFunction = async (value) => {
    const token = localStorage.getItem("token");
    let response = "";
    if (value.length === 5) {
      setLoaderVisible(true);
      response = await dispatch(checkIsZipCode(value, token));
      if (response.success) {
        setForm({
          ...form,
          locationCity: response?.data?.city,
          locationST: response?.data?.state,
          locationZip: response?.data?.zipCode,
        });
        errors.locationCity.error = false;
        errors.locationCity.dirty = false;
      } else {
        if (response?.data?.error?.message === "Invalid Zip Code.") {
          setModalContent("Invalid Zip Code");
          toggleModal();
          setForm({
            ...form,
            locationCity: "",
            locationST: "",
          });
        } else if (
          response.error?.message === "Invalid Token" ||
          response.message === "Request failed with status code 401"
        ) {
          history.push("/contact-us");
          window.location.reload(false);
        }
      }
      setLoaderVisible(false);
    }
  };

  return (
    <>
      {loaderVisible && <Spinner />}
      <form className={styles.form} onSubmit={onSubmitForm}>
        <Row>
          <Col md="6">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                First Name<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.firstname.dirty &&
                    errors.firstname.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="FirstName field"
                name="firstname"
                value={form.firstname}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.firstname.dirty && errors.firstname.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.firstname.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="6">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Last Name<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.lastname.dirty &&
                    errors.lastname.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="LastName field"
                name="lastname"
                value={form.lastname}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.lastname.dirty && errors.lastname.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.lastname.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="6">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Company Name<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.company.dirty &&
                    errors.company.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="Company field"
                name="company"
                value={form.company}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.company.dirty && errors.company.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.company.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="6">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Phone<span className="star">*</span>
              </label>
              <div className="phone-input-text">
                <NumberFormat
                  format="(###) ###-####"
                  name="phone"
                  className={clsx(
                    "phone-input",
                    styles.formField,
                    errors.phone.dirty &&
                      errors.phone.error &&
                      styles.formFieldError
                  )}
                  value={form.phone}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                />
              </div>
              {errors.phone.dirty && errors.phone.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.phone.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="6">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Email<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.email.dirty &&
                    errors.email.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="Email field"
                name="email"
                value={form.email}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.email.dirty && errors.email.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.email.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="6">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Confirm Email<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.confirmemail.dirty &&
                    errors.confirmemail.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="ConfirmEmail field"
                name="confirmemail"
                value={form.confirmemail}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.confirmemail.dirty && errors.confirmemail.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.confirmemail.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                City<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.locationCity.dirty &&
                    errors.locationCity.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="City field"
                name="locationCity"
                value={form.locationCity}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.locationCity.dirty && errors.locationCity.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.locationCity.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                State<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.locationST.dirty &&
                    errors.locationST.error &&
                    styles.formFieldError
                )}
                type="text"
                aria-label="State field"
                name="locationST"
                value={form.locationST}
                onChange={onUpdateField}
                onBlur={onBlurField}
                disabled
              />
              {errors.locationST.dirty && errors.locationST.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.locationST.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Zip<span className="star">*</span>
              </label>
              <input
                className={clsx(
                  styles.formField,
                  errors.locationZip.dirty &&
                    errors.locationZip.error &&
                    styles.formFieldError
                )}
                type="number"
                aria-label="Zip field"
                name="locationZip"
                maxLength="5"
                min="1"
                value={form.locationZip}
                // onChange={(e)=> { callFunction(e.target.value) }}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.locationZip.dirty && errors.locationZip.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.locationZip.message}
                </p>
              ) : null}
            </div>
          </Col>

          <Col md="12">
            <div style={{ "margin-top": "16px" }}>
              <SellPallets>
                <div className="my-2 label-color d-flex">
                  <p>Do you primarily buy or sell pallets?</p>
                  <PalletsContainer>
                    <div className="d-flex set-padding">
                      {buySellOptions &&
                        buySellOptions.map((value, index) => (
                          <div className="mr-4" key={index}>
                            <LocationWrapper>
                              <RadioButton
                                name="buySellOptions"
                                id={value.value}
                                value={form.buySellOptions}
                                defaultValue={buySellOptions[0].value}
                                onBlur={() => {}}
                                onSelect={(e) => {
                                  if (form.buySellOptions === "BUY") {
                                    setForm({
                                      ...form,
                                      buySellOptions: null,
                                      locationsOptions: null,
                                      annualOptions: null,
                                    });
                                  } else if (form.buySellOptions === "SELL") {
                                    setForm({
                                      ...form,
                                      buySellOptions: null,
                                      locationsOptions: null,
                                      annualOptions: null,
                                    });
                                  } else {
                                    setForm({
                                      ...form,
                                      buySellOptions: e.target.value,
                                    });
                                  }
                                }}
                                label={value.label}
                              />
                            </LocationWrapper>
                          </div>
                        ))}
                    </div>
                  </PalletsContainer>
                </div>
              </SellPallets>
            </div>
          </Col>
          {form.buySellOptions === "BUY" && (
            <Col md="12">
              <div style={{ "margin-top": "-22px" }}>
                <SellPallets>
                  <div className="my-2 label-color d-flex">
                    <p>Do you operate one or many locations?</p>
                    <PalletsContainer>
                      <div className="d-flex set-padding">
                        {locationsOptions &&
                          locationsOptions.map((value, index) => (
                            <div className="mr-4" key={index}>
                              <HardSoftWoodWrapper>
                                <RadioButton
                                  name="locationsOptions"
                                  id={value.value}
                                  value={form.locationsOptions}
                                  defaultValue={locationsOptions[0].value}
                                  onBlur={() => {}}
                                  onSelect={(e) => {
                                    if (form.locationsOptions === "ONE") {
                                      setForm({
                                        ...form,
                                        locationsOptions: null,
                                      });
                                    } else if (
                                      form.locationsOptions === "MANY"
                                    ) {
                                      setForm({
                                        ...form,
                                        locationsOptions: null,
                                      });
                                    } else {
                                      setForm({
                                        ...form,
                                        locationsOptions: e.target.value,
                                      });
                                    }
                                  }}
                                  label={value.label}
                                />
                              </HardSoftWoodWrapper>
                            </div>
                          ))}
                      </div>
                    </PalletsContainer>
                  </div>
                </SellPallets>
              </div>
            </Col>
          )}

          {form.buySellOptions === "BUY" && (
            <Col md="12">
              <div style={{ "margin-top": "-22px" }}>
                <div className="my-2 label-color d-flex">
                  <p>How many pallets do you buy on an annual basis?</p>
                </div>
                {/*   LESS_THAN_50000 BETWEEN_50001_AND_250000 MORE_THAN_250000 */}
                <AnnualBasis>
                  <div className="d-flex ">
                    {annualOptions &&
                      annualOptions.map((value, index) => (
                        <div className="mr-4" key={index}>
                          <HardSoftWoodWrapper>
                            <RadioButton
                              name="annualOptions"
                              id={value.value}
                              value={form.annualOptions}
                              defaultValue={annualOptions[0].value}
                              onBlur={() => {}}
                              onSelect={(e) => {
                                if (form.annualOptions === "LESS_THAN_50000") {
                                  setForm({
                                    ...form,
                                    annualOptions: null,
                                  });
                                } else if (
                                  form.annualOptions ===
                                  "BETWEEN_50001_AND_250000"
                                ) {
                                  setForm({
                                    ...form,
                                    annualOptions: null,
                                  });
                                } else if (
                                  form.annualOptions === "MORE_THAN_250000"
                                ) {
                                  setForm({
                                    ...form,
                                    annualOptions: null,
                                  });
                                } else {
                                  setForm({
                                    ...form,
                                    annualOptions: e.target.value,
                                  });
                                }
                              }}
                              label={value.label}
                            />
                          </HardSoftWoodWrapper>
                        </div>
                      ))}
                  </div>
                </AnnualBasis>
              </div>
            </Col>
          )}
          <Col
            md="12"
            style={
              form.buySellOptions === "BUY"
                ? { "margin-top": "5px" }
                : { "margin-top": "-5px" }
            }
          >
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Comment</label>
              <textarea
                className={clsx(
                  styles.formField,
                  errors.comment.dirty &&
                    errors.comment.error &&
                    styles.formFieldError
                )}
                aria-label="Comment field"
                name="comment"
                value={form.comment}
                onChange={onUpdateField}
                onBlur={onBlurField}
                style={{ "min-height": "70px" }}
              ></textarea>
              {errors.comment.dirty && errors.comment.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.comment.message}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md="6" className="mb-3 mt-5">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
              onChange={onRecaptchaChange}
            />
          </Col>
          <Col md="12">
            <div className={styles.formActions}>
              <button
                className={styles.formSubmitBtn}
                type="submit"
                disabled={!isFormValid || !captchaStatus}
              >
                Submit
              </button>
            </div>
          </Col>
        </Row>
      </form>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link=""
      />
    </>
  );
};

export default LoginForm;

const SellPallets = styled.div`
  @media (max-width: 903px) {
    .d-flex {
      display: block !important;
    }
  }
`;
const PalletsContainer = styled.div`
  display: grid;
  place-items: end;
  .d-flex {
    padding-left: 70px;
  }
  @media (max-width: 903px) {
    .d-flex {
      display: flex !important;
      padding-left: 0px;
    }
  }
  .set-padding {
    /* padding-top: 27px; */
    @media (max-width: 1023px) {
      padding-top: 5px;
    }
  }
`;

const AnnualBasis = styled.div`
  @media (max-width: 903px) {
    .d-flex {
      display: inline-grid !important;
      padding-left: 0px;
    }
  }
`;
const HardSoftWoodWrapper = styled.div`
  margin-right: 15px;
  .radio-checkmark {
    width: 18px;
    height: 18px;
    border-radius: 0px;
  }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
  }
  .radio-container {
    span {
      white-space: nowrap;
    }
  }
`;
const LocationWrapper = styled.div`
  margin-right: 19px;
  .radio-checkmark {
    width: 18px;
    height: 18px;
    border-radius: 0px;
  }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
  }
  .radio-container {
    span {
      white-space: nowrap;
    }
  }
`;
